import "./CosyLoader.css"


export default function CosyLoader(){
    return(
        /* From Uiverse.io by Nawsome */ 
<div className="Loaderboxes">
    <div className="Loaderbox">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="Loaderbox">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="Loaderbox">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="Loaderbox">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
    )
}